import React,{useState, useEffect}  from 'react';

import Sides from '../Bars/Jssidebar';
import Button from 'react-bootstrap/Button'
import { Helmet } from "react-helmet";
function Csswitch(){

  const [padding, setWindowpadding] = useState(0);
  const [width, setWindowWidth] = useState(0);
  useEffect(() => {
    updateDimensions()

    window.addEventListener('resize', updateDimensions)
    return () => window.removeEventListener('resize', updateDimensions)
  }, [])

  const updateDimensions = () => {
    const width = window.innerWidth
    setWindowWidth(width)
    if (width < 998) {
      setWindowpadding(2.5)
    } else {
      setWindowpadding(14)
    }
  }

  
  
return(
    <div>
      <Sides/>
      
      <Helmet>
 
 <title>Learn Free JavaScript Switch Tutorials For Beginners CodeExampler</title>
 <meta name="description" content="Javascript Switch tutorial for beginners.Switch in Javascript is a collection of similar type of data and stored in manually consecutively under one name CodeExampler provides Multiple Programming Examples for Beginners,CodeExampler provides Free Online Tutorials for beginners" />
 <meta name="keywords" content="codeexampler,tutorial for begineers,Javascript Switch for loop,Javascript foreach Switch,javascript switch case,javascript switch statement,javascript switch string,javascript switch example" />
 <link rel="canonical" href="https://www.codeexampler.com/javascript-switch" />
 </Helmet>

 <div className='lg:pl-56'>
    <h1 className="m-4 mh1">Javascript switch</h1>
    <div className="first">
        <a href="/javascript-if-else-if">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/javascript-looping-statement">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
    <h2 className="mt-4 mh2">Switch Statement in Javascript:</h2>
<p className="mt-4 para">That is also used in multiple conditions with different statements like if but it can only check the equality of the floating condition point, but the switch can’t match the value.</p>



<h2 className="headings">The Syntax for Switch Statement Javascript:</h2>
    <div
      style={{
        background: "#0f0e33",
        width: "94%",
        marginLeft: "3%",
        paddingLeft: "2%",
        borderRadius: "20px",
      }}
    >
      <pre style={{ maxHeight: "500vh" }}>
        <code>
        
      
     
  {"\n"} 

  <span className="qwerty-6">switch</span>
  <span className="qwerty-1">(</span>
        <span className="qwerty-4">Expression</span>
        <span className="qwerty-1">)</span>
  {"\n"}
  <span className="qwerty-3">&#123; </span>
  {"\n"}


  <span className="qwerty-10">&nbsp;case </span>
  <span className="qwerty-1">condition 1</span>
  <span className="qwerty"> : </span>
  {"\n"}
  <span className="qwerty-2">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Statement ;</span>

  {"\n"}
  <span className="qwerty">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Break;</span>

{"\n"}

  <span className="qwerty-10">&nbsp;case </span>
  <span className="qwerty-1">condition 2</span>
  <span className="qwerty"> : </span>
  {"\n"}
  <span className="qwerty-2">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Statement ;</span>

  {"\n"}
  <span className="qwerty">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Break;</span>

{"\n"}
<span className="qwerty-10">&nbsp;case </span>
  <span className="qwerty-1">condition 3</span>
  <span className="qwerty"> : </span>
  {"\n"}
  <span className="qwerty-2">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Statement ;</span>

  {"\n"}
  <span className="qwerty">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Break;</span>

{"\n"}
  <span className="qwerty-6">&nbsp;default</span>
  <span className="qwerty"> : </span>
  {"\n"}
  <span className="qwerty-2">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Statement ;</span>
      {"\n"}


 




          <span className="qwerty-3">&#125; </span>
            {"\n"}
    
            {"\n"}
    
            <span className="qwerty-5">OR </span>
            {"\n"}{"\n"}


    <span className="qwerty-6">switch</span>
  <span className="qwerty-1">(</span>
        <span className="qwerty-4">Expression</span>
        <span className="qwerty-1">)</span>
  {"\n"}


  <span className="qwerty-10">&nbsp;case </span>
  <span className="qwerty-1">condition 1</span>
  <span className="qwerty"> : </span>
  {"\n"}
  <span className="qwerty-2">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Statement ;</span>

  {"\n"}
  <span className="qwerty">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Break;</span>

{"\n"}

  <span className="qwerty-10">&nbsp;case </span>
  <span className="qwerty-1">condition 2</span>
  <span className="qwerty"> : </span>
  {"\n"}
  <span className="qwerty-2">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Statement ;</span>

  {"\n"}
  <span className="qwerty">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Break;</span>

{"\n"}
<span className="qwerty-10">&nbsp;case </span>
  <span className="qwerty-1">condition 3</span>
  <span className="qwerty"> : </span>
  {"\n"}
  <span className="qwerty-2">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Statement ;</span>

  {"\n"}
  <span className="qwerty">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Break;</span>

{"\n"}
  <span className="qwerty-6">&nbsp;default</span>
  <span className="qwerty"> : </span>
  {"\n"}
  <span className="qwerty-2">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Statement ;</span>
      {"\n"}

      <span className="qwerty-6">&nbsp;Endswitch;</span>
 
      {"\n"}{"\n"}


       
        </code>
      </pre>        
    </div>

<p className="m-3 para">In this keyword switch inside c programming that will yield an integer value, forex-case1,case2, etc. this is an integer constant<br/>
if you do not find any match in any case statements, so on that time, default statement execute
</p>


<p className="m-3 para">This program gives output but is not expecting because we did not provide case 3 and the default value Switch statement.<br/>
so if you want to provide the only case 2 statement so using switch case Javascript statement
</p>

<h2 className="m-3 mh2">Javascript switch statement without Using break Statement:</h2>


<h2 className="headings">Q-Write a program to input a no and print month name and if no is two by using switch without break Javascript?</h2>
    <div
      style={{
        background: "#0f0e33",
        width: "94%",
        marginLeft: "3%",
        paddingLeft: "2%",
        borderRadius: "20px",
      }}
    >
      <pre style={{ maxHeight: "500vh" }}>
        <code>
        
{"\n"}

<span className="qwerty-3">&#60;</span>
<span className="qwerty-8">script</span>
          <span className="qwerty-3">&#62; </span>
          {"\n"}


          <span className="qwerty-4">&nbsp;&nbsp;var </span>
          <span className="qwerty-3">month</span>
          <span className="qwerty">=</span>
          <span className="qwerty-1">3;</span>
          {"\n"}


          {"\n"} 

<span className="qwerty-6">&nbsp;&nbsp;switch</span>
<span className="qwerty-1">(</span>
      <span className="qwerty-4">month</span>
      <span className="qwerty-1">)</span>
{"\n"}
<span className="qwerty-3">&nbsp;&nbsp;&#123; </span>
{"\n"}


<span className="qwerty-6">&nbsp;&nbsp;&nbsp;case </span>
<span className="qwerty-1">1</span>
<span className="qwerty"> : </span>
{"\n"}
  <span className="qwerty-2">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;document</span>
      <span className="qwerty">.</span>
      <span className="qwerty-2">write</span>
      <span className="qwerty-1">(</span>
        <span className="qwerty-1">"</span> 
        <span className="qwerty-3">Jan</span> 
        <span className="qwerty-1">"</span> 
   
      <span className="qwerty-1">);</span>
      {"\n"}
      <span className="qwerty-10">break;</span>
      {"\n"}
      <span className="qwerty-6">&nbsp;&nbsp;&nbsp;case </span>
<span className="qwerty-1">2</span>
<span className="qwerty"> : </span>
{"\n"}
  <span className="qwerty-2">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;document</span>
      <span className="qwerty">.</span>
      <span className="qwerty-2">write</span>
      <span className="qwerty-1">(</span>
      <span className="qwerty-1">"</span> 
        <span className="qwerty-3">Feb</span> 
        <span className="qwerty-1">"</span> 

      <span className="qwerty-1">);</span>
      {"\n"}

      <span className="qwerty-6">&nbsp;&nbsp;&nbsp;case </span>
<span className="qwerty-1">3</span>
<span className="qwerty"> : </span>
{"\n"}
  <span className="qwerty-2">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;document</span>
      <span className="qwerty">.</span>
      <span className="qwerty-2">write</span>
      <span className="qwerty-1">(</span>
      <span className="qwerty-1">"</span> 
        <span className="qwerty-3">Mar</span> 
        <span className="qwerty-1">"</span>
  
      <span className="qwerty-1">);</span>
      {"\n"}

      <span className="qwerty-6">&nbsp;&nbsp;&nbsp;case </span>
<span className="qwerty-1">4</span>
<span className="qwerty"> : </span>
{"\n"}
  <span className="qwerty-2">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;document</span>
      <span className="qwerty">.</span>
      <span className="qwerty-2">write</span>
      <span className="qwerty-1">(</span>
      <span className="qwerty-1">"</span> 
        <span className="qwerty-3">Apr</span> 
        <span className="qwerty-1">"</span>
  
      <span className="qwerty-1">);</span>
      {"\n"}

      <span className="qwerty-6">&nbsp;&nbsp;&nbsp;default </span>
<span className="qwerty">: </span>
{"\n"}
  <span className="qwerty-2">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;document</span>
      <span className="qwerty">.</span>
      <span className="qwerty-2">write</span>
      <span className="qwerty-1">(</span>
      <span className="qwerty-1">"</span> 
        <span className="qwerty-3">Enter correct value</span> 
        <span className="qwerty-1">"</span>
      <span className="qwerty-1">);</span>
      {"\n"}

      <span className="qwerty-3">&#125; </span>
          {"\n"}

<span className="qwerty-3">&#60;/</span>
<span className="qwerty-8">script</span>
          <span className="qwerty-3">&#62; </span>
            {"\n"}
    
    
    
            {"\n"}
       
        </code>
      </pre>        
    </div>
    
    <div>
      <h3 className="headings">Output</h3>
      <div style={{background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code className="python hljs">
          {"\n"}
          <span className="qwerty-3">&nbsp;Mar</span>          
          {"\n"} 
          <span className="qwerty-3">&nbsp;Apr</span>          
          {"\n"} 
          <span className="qwerty-3">&nbsp;enter correct value</span>          
          {"\n"} 
          
            </code>{"   "}
            </pre>
      </div>
    </div>


<h2 className="mt-4 mh2">Javascript switch statement with break:</h2>


<h2 className="headings">Q-Write a program to input a no and print month name and if no is two by using Switch Javascript?</h2>
    <div
      style={{
        background: "#0f0e33",
        width: "94%",
        marginLeft: "3%",
        paddingLeft: "2%",
        borderRadius: "20px",
      }}
    >
      <pre style={{ maxHeight: "500vh" }}>
        <code>
        
{"\n"}

<span className="qwerty-3">&#60;</span>
<span className="qwerty-8">script</span>
          <span className="qwerty-3">&#62; </span>
          {"\n"}


          <span className="qwerty-4">&nbsp;&nbsp;var </span>
          <span className="qwerty-3">month</span>
          <span className="qwerty">=</span>
          <span className="qwerty-1">3;</span>
          {"\n"}


          {"\n"} 

<span className="qwerty-6">&nbsp;&nbsp;switch</span>
<span className="qwerty-1">(</span>
      <span className="qwerty-4">month</span>
      <span className="qwerty-1">)</span>
{"\n"}
<span className="qwerty-3">&nbsp;&nbsp;&#123; </span>
{"\n"}


<span className="qwerty-6">&nbsp;&nbsp;&nbsp;case </span>
<span className="qwerty-1">1</span>
<span className="qwerty"> : </span>
{"\n"}
  <span className="qwerty-2">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;document</span>
      <span className="qwerty">.</span>
      <span className="qwerty-2">write</span>
      <span className="qwerty-1">(</span>
      <span className="qwerty-1">"</span> 
        <span className="qwerty-3">Jan</span> 
        <span className="qwerty-1">"</span>
      <span className="qwerty-1">);</span>
      {"\n"}
      <span className="qwerty">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;break;</span>
      {"\n"}

      <span className="qwerty-6">&nbsp;&nbsp;&nbsp;case </span>
<span className="qwerty-1">2</span>
<span className="qwerty"> : </span>
{"\n"}
  <span className="qwerty-2">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;document</span>
      <span className="qwerty">.</span>
      <span className="qwerty-2">write</span>
      <span className="qwerty-1">(</span>
      <span className="qwerty-1">"</span> 
        <span className="qwerty-3">Feb</span> 
        <span className="qwerty-1">"</span>
      <span className="qwerty-1">);</span>
      {"\n"}
      <span className="qwerty">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;break;</span>
      {"\n"}

      <span className="qwerty-6">&nbsp;&nbsp;&nbsp;case </span>
<span className="qwerty-1">3</span>
<span className="qwerty"> : </span>
{"\n"}
  <span className="qwerty-2">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;document</span>
      <span className="qwerty">.</span>
      <span className="qwerty-2">write</span>
      <span className="qwerty-1">(</span>
      <span className="qwerty-1">"</span> 
        <span className="qwerty-3">Mar</span> 
        <span className="qwerty-1">"</span> 
      <span className="qwerty-1">)</span>
      {"\n"}
      <span className="qwerty">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;break;</span>
      {"\n"}

      <span className="qwerty-6">&nbsp;&nbsp;&nbsp;case </span>
<span className="qwerty-1">4</span>
<span className="qwerty"> : </span>
{"\n"}
  <span className="qwerty-2">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;document</span>
      <span className="qwerty">.</span>
      <span className="qwerty-2">write</span>
      <span className="qwerty-1">(</span>
      <span className="qwerty-1">"</span> 
        <span className="qwerty-3">Apr</span> 
        <span className="qwerty-1">"</span>
      <span className="qwerty-1">);</span>
      {"\n"}
      <span className="qwerty">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;break;</span>
      {"\n"}

      <span className="qwerty-6">&nbsp;&nbsp;&nbsp;default</span>
<span className="qwerty">: </span>
{"\n"}
  <span className="qwerty-2">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;document</span>
      <span className="qwerty">.</span>
      <span className="qwerty-2">write</span>
      <span className="qwerty-1">(</span>
      <span className="qwerty-1">"</span> 
        <span className="qwerty-3">Enter correct value</span> 
        <span className="qwerty-1">"</span>
      <span className="qwerty-1">);</span>
      {"\n"}

      <span className="qwerty">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;break;</span>
      {"\n"}
      <span className="qwerty-3">&#125; </span>
          {"\n"}
<span className="qwerty-3">&#60;/</span>
<span className="qwerty-8">script</span>
          <span className="qwerty-3">&#62; </span>
            {"\n"}
    
    
    
            {"\n"}
       
        </code>
      </pre>        
    </div>
    
    <div>
      <h3 className="headings">Output</h3>
      <div style={{background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code className="python hljs">
          {"\n"}
          <span className="qwerty-3">&nbsp;Mar</span>          
          {"\n"} 
          
            </code>{"   "}
            </pre>
      </div>
    </div>


<h2 className="headings">Q-Write a program without input use a switch case in Javascript?</h2>
    <div
      style={{
        background: "#0f0e33",
        width: "94%",
        marginLeft: "3%",
        paddingLeft: "2%",
        borderRadius: "20px",
      }}
    >
      <pre style={{ maxHeight: "500vh" }}>
        <code>
        
{"\n"}

<span className="qwerty-3">&#60;</span>
<span className="qwerty-8">script</span>
          <span className="qwerty-3">&#62; </span>
          {"\n"}


          <span className="qwerty-4">&nbsp;&nbsp;var </span>
          <span className="qwerty-3">i</span>
          <span className="qwerty">=</span>
          <span className="qwerty-1">280;</span>
          {"\n"}


          {"\n"} 

<span className="qwerty-6">&nbsp;&nbsp;switch</span>
<span className="qwerty-1">(</span>
      <span className="qwerty-4">i</span>
      <span className="qwerty-1">)</span>
{"\n"}
<span className="qwerty-3">&nbsp;&nbsp;&#123; </span>
{"\n"}


      <span className="qwerty-6">&nbsp;&nbsp;&nbsp;case </span>
<span className="qwerty-1">180</span>
<span className="qwerty"> : </span>
{"\n"}
  <span className="qwerty-2">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;document</span>
      <span className="qwerty">.</span>
      <span className="qwerty-2">write</span>
      <span className="qwerty-1">(</span>
      <span className="qwerty-1">"</span> 
        <span className="qwerty-3">i value is 180</span> 
        <span className="qwerty-1">"</span> 
      <span className="qwerty-1">);</span>
      {"\n"}
      <span className="qwerty">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;break;</span>
      {"\n"}

      <span className="qwerty-6">&nbsp;&nbsp;&nbsp;case </span>
<span className="qwerty-1">280</span>
<span className="qwerty"> : </span>
{"\n"}
  <span className="qwerty-2">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;document</span>
      <span className="qwerty">.</span>
      <span className="qwerty-2">write</span>
      <span className="qwerty-1">(</span>
        <span className="qwerty-1">"</span> 
        <span className="qwerty-3">i value is 280</span> 
        <span className="qwerty-1">"</span> 
      <span className="qwerty-1">)</span>
      {"\n"}
      <span className="qwerty">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;break;</span>
      {"\n"}

      <span className="qwerty-6">&nbsp;&nbsp;&nbsp;case </span>
<span className="qwerty-1">480</span>
<span className="qwerty"> : </span>
{"\n"}
  <span className="qwerty-2">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;document</span>
      <span className="qwerty">.</span>
      <span className="qwerty-2">write</span>
      <span className="qwerty-1">(</span>
      <span className="qwerty-1">"</span> 
        <span className="qwerty-3">i value is 480</span> 
        <span className="qwerty-1">"</span>
      <span className="qwerty-1">);</span>
      {"\n"}
      <span className="qwerty">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;break;</span>
      {"\n"}

      <span className="qwerty-6">&nbsp;&nbsp;&nbsp;default</span>
<span className="qwerty">: </span>
{"\n"}
  <span className="qwerty-2">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;document</span>
      <span className="qwerty">.</span>
      <span className="qwerty-2">write</span>
      <span className="qwerty-1">(</span>
      <span className="qwerty-1">"</span> 
        <span className="qwerty-3">Enter correct value</span> 
        <span className="qwerty-1">"</span>
      <span className="qwerty-1">);</span>
      {"\n"}

      <span className="qwerty">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;break;</span>
      {"\n"}
      <span className="qwerty-3">&#125; </span>
          {"\n"}
<span className="qwerty-3">&#60;/</span>
<span className="qwerty-8">script</span>
          <span className="qwerty-3">&#62; </span>
            {"\n"}
    
    
    
            {"\n"}
       
        </code>
      </pre>        
    </div>
    
    <div>
      <h3 className="headings">Output</h3>
      <div style={{background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code className="python hljs">
          {"\n"}
          <span className="qwerty-3">&nbsp;i value is 280</span>          
          {"\n"} 
          
            </code>{"   "}
            </pre>
      </div>
    </div>



<h2 className="headings">Q-Write a program character switch case in Javascript?</h2>
    <div
      style={{
        background: "#0f0e33",
        width: "94%",
        marginLeft: "3%",
        paddingLeft: "2%",
        borderRadius: "20px",
      }}
    >
      <pre style={{ maxHeight: "500vh" }}>
        <code>
        
{"\n"}

<span className="qwerty-3">&#60;</span>
<span className="qwerty-8">script</span>
          <span className="qwerty-3">&#62; </span>
          {"\n"}


          <span className="qwerty-4">&nbsp;&nbsp;var </span>
          <span className="qwerty-3">i</span>
          <span className="qwerty">=</span>
          <span className="qwerty-1">'d';</span>
          {"\n"}


          {"\n"} 

<span className="qwerty-6">&nbsp;&nbsp;switch</span>
<span className="qwerty-1">(</span>
      <span className="qwerty-4">i</span>
      <span className="qwerty-1">)</span>
{"\n"}
<span className="qwerty-3">&nbsp;&nbsp;&#123; </span>
{"\n"}

<span className="qwerty-6">&nbsp;&nbsp;&nbsp;case </span>
<span className="qwerty-1">'b'</span>
<span className="qwerty"> : </span>
{"\n"}
  <span className="qwerty-2">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;document</span>
      <span className="qwerty">.</span>
      <span className="qwerty-2">write</span>
      <span className="qwerty-1">(</span>
      <span className="qwerty-1">"</span> 
        <span className="qwerty-3">i value is b</span> 
        <span className="qwerty-1">"</span> 
      <span className="qwerty-1">);</span>
      {"\n"}
      <span className="qwerty">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;break;</span>
      {"\n"}

      <span className="qwerty-6">&nbsp;&nbsp;&nbsp;case </span>
<span className="qwerty-1">'d'</span>
<span className="qwerty"> : </span>
{"\n"}
  <span className="qwerty-2">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;document</span>
      <span className="qwerty">.</span>
      <span className="qwerty-2">write</span>
      <span className="qwerty-1">(</span>
      <span className="qwerty-1">"</span> 
        <span className="qwerty-3">i value is d</span> 
        <span className="qwerty-1">"</span>  
      <span className="qwerty-1">);</span>
      {"\n"}
      <span className="qwerty">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;break;</span>
      {"\n"}

      <span className="qwerty-6">&nbsp;&nbsp;&nbsp;case </span>
<span className="qwerty-1">'f'</span>
<span className="qwerty"> : </span>
{"\n"}
  <span className="qwerty-2">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;document</span>
      <span className="qwerty">.</span>
      <span className="qwerty-2">write</span>
      <span className="qwerty-1">(</span>
      <span className="qwerty-1">"</span> 
        <span className="qwerty-3">i value is f</span> 
        <span className="qwerty-1">"</span> 
        <span className="qwerty-1">)</span> 
      {"\n"}
      <span className="qwerty">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;break;</span>
      {"\n"}

      <span className="qwerty-6">&nbsp;&nbsp;&nbsp;case </span>
<span className="qwerty-1">'h'</span>
<span className="qwerty"> : </span>
{"\n"}
  <span className="qwerty-2">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;document</span>
      <span className="qwerty">.</span>
      <span className="qwerty-2">write</span>
      <span className="qwerty-1">(</span>
      <span className="qwerty-1">"</span> 
        <span className="qwerty-3">i value is h</span> 
        <span className="qwerty-1">"</span> 
      <span className="qwerty-1">);</span>
      {"\n"}
      <span className="qwerty">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;break;</span>
      {"\n"}

      <span className="qwerty-6">&nbsp;&nbsp;&nbsp;default</span>
<span className="qwerty">: </span>
{"\n"}
  <span className="qwerty-2">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;document</span>
      <span className="qwerty">.</span>
      <span className="qwerty-2">write</span>
      <span className="qwerty-1">(</span>
      <span className="qwerty-1">"</span> 
        <span className="qwerty-3">Enter correct value</span> 
        <span className="qwerty-1">"</span> 
      <span className="qwerty-1">);</span>
      {"\n"}

      <span className="qwerty">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;break;</span>
      {"\n"}
      <span className="qwerty-3">&#125; </span>
          {"\n"}
<span className="qwerty-3">&#60;/</span>
<span className="qwerty-8">script</span>
          <span className="qwerty-3">&#62; </span>
            {"\n"}
    
    
    
            {"\n"}
       
        </code>
      </pre>        
    </div>
    
    <div>
      <h3 className="headings">Output</h3>
      <div style={{background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code className="python hljs">
          {"\n"}
          <span className="qwerty-3">&nbsp;i value is d</span>          
          {"\n"} 
          
            </code>{"   "}
            </pre>
      </div>
    </div>




<h2 className="headings">Q-Write a program to check a no b/w two no switch case in Javascript?</h2>
    <div
      style={{
        background: "#0f0e33",
        width: "94%",
        marginLeft: "3%",
        paddingLeft: "2%",
        borderRadius: "20px",
      }}
    >
      <pre style={{ maxHeight: "500vh" }}>
        <code>
        
{"\n"}

<span className="qwerty-3">&#60;</span>
<span className="qwerty-8">script</span>
          <span className="qwerty-3">&#62; </span>
          {"\n"}


          <span className="qwerty-4">&nbsp;&nbsp;var </span>
          <span className="qwerty-3">date</span>
          <span className="qwerty">=</span>
          <span className="qwerty-1">8;</span>
          {"\n"}


          {"\n"} 

<span className="qwerty-6">&nbsp;&nbsp;switch</span>
<span className="qwerty-1">(</span>
      <span className="qwerty-4">true</span>
      <span className="qwerty-1">)</span>
{"\n"}
<span className="qwerty-3">&nbsp;&nbsp;&#123; </span>
{"\n"}

      <span className="qwerty-6">&nbsp;&nbsp;&nbsp;case </span>
      <span className="qwerty-1">(</span>
      <span className="qwerty-3">date</span>
      <span className="qwerty">&#62;=</span>
      <span className="qwerty-1">10</span>
      <span className="qwerty"> && </span>
      <span className="qwerty-3">date</span>
      <span className="qwerty">&#60;=</span>
      <span className="qwerty-1">20</span>
<span className="qwerty-1">)</span>
<span className="qwerty"> : </span>
{"\n"}
  <span className="qwerty-2">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;document</span>
      <span className="qwerty">.</span>
      <span className="qwerty-2">write</span>
      <span className="qwerty-1">(</span>
      <span className="qwerty-1">"</span> 
        <span className="qwerty-3">your date is correct</span> 
        <span className="qwerty-1">"</span>  
        <span className="qwerty-1">);</span>  
      {"\n"}
      <span className="qwerty">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;break;</span>
      {"\n"}

      <span className="qwerty-6">&nbsp;&nbsp;&nbsp;case </span>
      <span className="qwerty-1">(</span>
      <span className="qwerty-3">date</span>
      <span className="qwerty">&#62;=</span>
      <span className="qwerty-1">21</span>
      <span className="qwerty"> && </span>
      <span className="qwerty-3">date</span>
      <span className="qwerty">&#60;=</span>
      <span className="qwerty-1">32</span>
<span className="qwerty-1">)</span>
<span className="qwerty"> : </span>
{"\n"}
  <span className="qwerty-2">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;document</span>
      <span className="qwerty">.</span>
      <span className="qwerty-2">write</span>
      <span className="qwerty-1">(</span>
      <span className="qwerty-1">"</span> 
        <span className="qwerty-3">your date is incorrect</span> 
        <span className="qwerty-1">"</span> 
      <span className="qwerty-1">);</span>
      {"\n"}
      <span className="qwerty">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;break;</span>
      {"\n"}

      <span className="qwerty-6">&nbsp;&nbsp;&nbsp;default</span>
<span className="qwerty">: </span>
{"\n"}
  <span className="qwerty-2">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;document</span>
      <span className="qwerty">.</span>
      <span className="qwerty-2">write</span>
      <span className="qwerty-1">(</span>
      <span className="qwerty-1">"</span> 
        <span className="qwerty-3">Please enter a valid date</span> 
        <span className="qwerty-1">"</span> 
      <span className="qwerty-1">);</span>
      {"\n"}

      <span className="qwerty">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;break;</span>
      {"\n"}
      <span className="qwerty-3">&#125; </span>
          {"\n"}
<span className="qwerty-3">&#60;/</span>
<span className="qwerty-8">script</span>
          <span className="qwerty-3">&#62; </span>
            {"\n"}
    
    
    
            {"\n"}
       
        </code>
      </pre>        
    </div>
    
    <div>
      <h3 className="headings">Output</h3>
      <div style={{background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code className="python hljs">
          {"\n"}
          <span className="qwerty-3">&nbsp;Please enter a valid date</span>          
          {"\n"} 
          
            </code>{"   "}
            </pre>
      </div>
    </div>

  <h1 className="mt-5">  </h1>
   
  <div className="back">
        <a href="/javascript-if-else-if">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/javascript-looping-statement">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
        </div>
    </div>
)

}
export default Csswitch;